import {
  DEFAULT_WORLD_BALANCE,
  type WorldBalance,
} from "../../models/config/worldBalance.ts";
import type { DomainEvent } from "../../models/events.ts";
import type { WorldState } from "../../models/worldState.ts";
import { applyForcedRandomEvent } from "../events/applyForcedRandomEvent.ts";
import { pushNotification } from "../notifications/notificationStore.ts";
import type { MapTimelineBeat } from "./mapDefinition.ts";
import { resolveTimelineNotifyCopy } from "./resolveTimelineNotifyCopy.ts";

export function applyMapTimelineBeats(
  state: WorldState,
  beats: readonly MapTimelineBeat[],
  playingTurnEnded: number,
  activationTurn: number,
  timelineStrings?: Readonly<Record<string, unknown>>,
  balance: WorldBalance = DEFAULT_WORLD_BALANCE,
): { state: WorldState; events: DomainEvent[] } {
  let current = state;
  const events: DomainEvent[] = [];

  for (const beat of beats) {
    if (beat.atTurn !== playingTurnEnded) {
      continue;
    }

    if (beat.verb === "notify") {
      const copy = resolveTimelineNotifyCopy(beat, timelineStrings);
      const pushed = pushNotification(current.notifications, {
        messages: [copy],
      });
      current = {
        ...current,
        notifications: pushed.state,
      };
      events.push({
        type: "NotificationPushed",
        id: pushed.id,
      });
      continue;
    }

    const forced = applyForcedRandomEvent(
      current,
      beat.eventId,
      activationTurn,
      beat.tile,
      balance,
    );
    current = {
      ...current,
      randomEvent: forced.randomEvent,
      rng: forced.rng,
    };
    events.push(...forced.events);
  }

  return { state: current, events };
}
